
import React, {useState} from "react";
import {AccountService} from "../../service/AccountService";
import {emailValidator, formValid, getKeyValue, user} from "../../utils/Utils";

import {Button} from "primereact/button";
import {AuthService} from "../../service/AuthService";
import {InputText} from "primereact/inputtext";
import {Message} from "primereact/message";
import {Password} from "primereact/password";
import {AppContext} from "../../HomePage";


const initials = (name, email) => {
    const n = (name || "").trim();
    if (n) { const p = n.split(/\s+/); return ((p[0][0] || "") + (p[1] ? p[1][0] : "")).toUpperCase(); }
    return (email || "?").substring(0, 1).toUpperCase();
};

const Profile = (props) => {

    const {t, toast, setError} = React.useContext(AppContext);

    const [currentUser, setCurrentUser] = useState(user());
    const [profile, setProfile] = useState(user().profile ?? []);
    const [newProfile, setNewProfile] = useState({name:"", email:"", password:"", read_only:true});
    const [formErrors, setFormErrors] = useState({name:"", email:"", password:"", read_only:true});
    const [disabled, setDisabled] = useState(false);
    const [showAdd, setShowAdd] = useState(false);

    const accountService = new AccountService();

    const add = () => {

        if (profile.some(s => s.email === newProfile.email) || newProfile.email === currentUser.email)
        {
            toast.current.show({severity: 'warn', summary: t('user.profile.exist'), detail: ""});
            return;
        }

        checkErrors(newProfile).then(formErrors=> {
            if (formValid(formErrors)) {
                profile.push(newProfile);
                setProfile([...profile]);
                save();
            }
            else
                setFormErrors(formErrors);
        });
    };

    const deleteProfile = (rowData) => {
        profile.splice(profile.findIndex(n => n.email === rowData.email),1);
        setProfile([...profile]);
        save();
    };

    const onChange = (e) =>{
        const { key, value } = getKeyValue(e);
        setFormErrors({...formErrors, [key]: checkError(key, value)});
        setNewProfile({...newProfile, [key] : value});
    };

    const errorClass = (key) => {
        return formErrors[key] && formErrors[key].length > 0 ? "p-error" : null
    };

    const checkError = (key, value) => {
        let errorText = "";

        if (key === "name") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }
        else if (key === "email") {
            errorText =  value.length > 0 ? emailValidator(value, t) : t('validations.invalid_email');
        }
        else if (key === "password") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }

        return errorText;
    }

    const checkErrors = async (profile) => {

        let errors = { ...formErrors };

        Object.entries(profile).forEach(([key, value]) => {
            errors[key] = checkError(key, value);
        });

        return errors;
    };

    const save =() => {

        if (disabled) {
            return;
        }
        setDisabled(true);

        currentUser.profile = profile;

        accountService.updateMyAccount(currentUser).then(user_updated=>{
            AuthService.setUser(user_updated);
            setCurrentUser({...user_updated});
            setProfile([...user_updated.profile])
            toast.current.show({severity: 'success', summary: t('account.save_profile'), detail: t('message_detail.successful')});
            setDisabled(false);
            setNewProfile({name:"", email:"", password:"", read_only: true});
            setShowAdd(false);
        }).catch(error =>{
            setError(error);
            setError(null);
            setDisabled(false);
        });

    };

    const authorizations =  [
        {label: t('user.profile.read_only'), value: true},
        {label: t('user.profile.read_write'), value: false},
    ];

    return (
        <div className="acc-section acc-narrow">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 2 }}>
                <p className="acc-section-title" style={{ margin: 0 }}>{t('account.headers.profile', 'Team members')}</p>
                <span className="acc-role acc-role--ro">{(profile.length + 1)} {t('account.team.count', 'members')}</span>
                <Button label={t('actions.add', 'Add member')} icon="pi pi-plus"
                        className="p-button-outlined p-button-success p-ml-auto" style={{ marginLeft: 'auto' }}
                        onClick={() => setShowAdd(s => !s)} />
            </div>
            <p className="acc-section-sub">{t('user.profile.message', 'Invite teammates and set each one\'s access level.')}</p>

            {showAdd &&
                <div className="acc-addform">
                    <div className="acc-addform-head">
                        <span className="acc-addform-title">{t('account.team.invite_title', 'Invite a team member')}</span>
                        <button type="button" className="acc-addform-x" aria-label={t('actions.cancel', 'Cancel')} onClick={() => setShowAdd(false)}>
                            <i className="pi pi-times" />
                        </button>
                    </div>
                    <div className="p-fluid">
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 acc-field">
                                <label>{t('user.name', 'Name')}</label>
                                <InputText name="name" value={newProfile.name} onChange={onChange} className={errorClass("name")} />
                                {errorClass("name") && <Message severity="error" text={formErrors.name} />}
                            </div>
                            <div className="p-col-12 p-md-6 acc-field">
                                <label>{t('user.profile.email', 'Email')}</label>
                                <InputText name="email" value={newProfile.email} onChange={onChange} className={errorClass("email")} />
                                {errorClass("email") && <Message severity="error" text={formErrors.email} />}
                            </div>
                            <div className="p-col-12 acc-field">
                                <label>{t('user.password', 'Password')}</label>
                                <Password name="password" value={newProfile.password} onChange={onChange} feedback={false} className={errorClass("password")} />
                                {errorClass("password") && <Message severity="error" text={formErrors.password} />}
                            </div>
                        </div>
                    </div>
                    <label className="acc-addform-lbl">{t('user.profile.authorization', 'Access level')}</label>
                    <div className="acc-role-cards">
                        <button type="button" className={"acc-role-card" + (!newProfile.read_only ? " is-selected" : "")}
                                onClick={() => onChange({ target: { name: 'read_only', value: false } })}>
                            <span className="acc-role-radio" />
                            <span>
                                <span className="acc-role-card-t">{t('user.profile.read_write', 'Can edit')}</span>
                                <span className="acc-role-card-d">{t('user.profile.read_write_hint', 'Can view and edit campaigns, products and prices.')}</span>
                            </span>
                        </button>
                        <button type="button" className={"acc-role-card" + (newProfile.read_only ? " is-selected" : "")}
                                onClick={() => onChange({ target: { name: 'read_only', value: true } })}>
                            <span className="acc-role-radio" />
                            <span>
                                <span className="acc-role-card-t">{t('user.profile.read_only', 'Read-only')}</span>
                                <span className="acc-role-card-d">{t('user.profile.read_only_hint', 'Can view everything; cannot make changes.')}</span>
                            </span>
                        </button>
                    </div>
                    <div className="acc-addform-actions">
                        <Button label={t('actions.cancel', 'Cancel')} className="p-button-text" onClick={() => setShowAdd(false)} />
                        <Button label={t('actions.add', 'Add member')} icon="pi pi-check" className="p-button-success" onClick={add} disabled={disabled} />
                    </div>
                </div>}

            <div className="acc-row">
                <div className="acc-avatar" style={{ width: 32, height: 32, fontSize: 12 }}>{initials(currentUser.first_name + ' ' + currentUser.last_name, currentUser.email)}</div>
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13.5, fontWeight: 600 }}>{(currentUser.first_name || '') + ' ' + (currentUser.last_name || '')}</div>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>{currentUser.email}</div>
                </div>
                <span className="acc-role acc-role--owner">{t('account.team.owner', 'You · Owner')}</span>
            </div>

            {profile.map(m => (
                <div className="acc-row" key={m.email}>
                    <div className="acc-avatar" style={{ width: 32, height: 32, fontSize: 12, background: '#534AB7' }}>{initials(m.name, m.email)}</div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 600 }}>{m.name}</div>
                        <div style={{ fontSize: 12, color: '#6b7280' }}>{m.email}</div>
                    </div>
                    <span className={"acc-role " + (m.read_only ? "acc-role--ro" : "acc-role--rw")}>
                        {m.read_only ? t('user.profile.read_only', 'Read-only') : t('user.profile.read_write', 'Can edit')}
                    </span>
                    <Button icon="pi pi-trash" className="p-button-text p-button-rounded p-button-danger"
                            tooltip={t('actions.remove', 'Remove')} onClick={() => deleteProfile(m)} />
                </div>
            ))}

            {profile.length === 0 && <div className="acc-empty">{t('account.team.empty', 'No team members yet. Add one to get started.')}</div>}
        </div>
    );
};
export default Profile
